import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';

// Components
import { CatalogHistory } from '@mobilitystore/components-interface';
import CustomizedSnackbars from '../../../components/Shared/Utils/SnackBar';

// Constants
import idConstants from '../../../data/idConstants';

// Actions
import { regenerateAAATokens } from '../../../actions/LoginAction';

// Utils
import { getEnvironment } from '../../../utils';

// CSS
import '../index.scss';
import './index.scss';

const BulkProductHistoryContainer = () => {
  const dispatch = useDispatch();
  const initialSnackbarState = {
    status: '',
    show: false
  };

  const [snackbarStatus, setSnackbarStatus] = React.useState(initialSnackbarState);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const handleBulkProductHistoryError = (error) => {
    setSnackbarStatus({
      status: 'error',
      message: error.message,
      show: true
    });

    if (error.error === 'ERR_NETWORK') {
      dispatch(regenerateAAATokens()).then(() => {
        window.location.reload();
      });
    }
  };

  return (
    <div>
      {snackbarStatus.show && (
        <CustomizedSnackbars
          severity={snackbarStatus.status}
          message={snackbarStatus.message}
          changeState={() => setSnackbarStatus(initialSnackbarState)}
        />
      )}
      <CatalogHistory
        className='bulk-product-history'
        token={localStorage.getItem(idConstants.tokens.aaaIdToken)}
        environment={getEnvironment(process.env.REACT_APP_ENVIRONMENT)}
        tenantId={process.env.REACT_APP_SELLER_TENANT_ID}
        onError={handleBulkProductHistoryError}
        isBulkOnboarding={true}
      />
    </div>
  );
};

export default BulkProductHistoryContainer;
